var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat"},[(_vm.url)?_c('a',{attrs:{"href":_vm.url}},[_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))]),_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_c('span',[_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))]),_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }